import { QueryClient } from '@tanstack/react-query';

const client = new QueryClient();

export default client;
